<div class="grid">
	<div class="col-12">
		<div class="card">
			<div class="formgroup">
				<div class="p-fluid p-formgrid grid">
					<!-- <div class="field col-12 md:col-2">
						<button pButton pRipple routerLink="/apps/indicador-cliente/inserir" label="Novo" icon="pi pi-plus"
							class="p-button-outlined sm:w-9rem"></button>
					</div> -->
				</div>
			</div>
			<div *ngIf="messagemVisivel" class="field col-12 md:col-12">
				<p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
			</div>
			<p-table #dt1 [value]="pageBaseConhecimento.content" dataKey="id"
				[rows]="pageBaseConhecimento.size" [paginator]="true"
                [totalRecords]="pageBaseConhecimento.totalElements" 
                [lazy]="true"
                [loading]="loading"
                [rowHover]="true"
                (onLazyLoad)="onLazyLoad($event)"
                [showCurrentPageReport]="true"
				[paginator]="true"
				[loading]="loading"
				[rowHover]="true"
				responsiveLayout="scroll" styleClass=" p-datatable-sm"
				currentPageReportTemplate="Mostrando {first} ao {last} de {totalRecords} registros">
				<ng-template pTemplate="caption">
					<div class="flex justify-content-between flex-column sm:flex-row">
						<div class="p-fluid">
                                <label>Tipo</label>
                                <p-dropdown [options]="listaTiposAtendimento" optionLabel="label" optionValue="value"
                                    emptyFilterMessage="Nenhum registro" name="tipoAtendimento" ngModel
                                    #tipoAtendimento="ngModel" placeholder="Selecione"
                                    [(ngModel)]="tipoAtendimentoSelecionado" (onChange)="alterarFiltro(dt1)">
                                </p-dropdown>
                            </div>
						<div class="p-fluid mt-2 sm:mt-4">
							<div class="flex">
								<span class="p-input-icon-left">
									<i class="pi pi-search"></i>
									<input pInputText type="text" [(ngModel)]="inputBusca" (input)="buscar(dt1, $event)" placeholder="Buscar"
										class="w-full" />
								</span>
								<span class="ml-2">
									<button pButton class="p-button-outlined" icon="pi pi-filter-slash"
										pTooltip="Limpar Filtros" (click)="limpar(dt1)"></button>
								</span>
							</div>

						</div>
						
					</div>
				</ng-template>
				<ng-template pTemplate="header">
					<tr>
						
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-item>
					<tr >
						<div class="card-simple mt-2 cursor-pointer"
						 (click)="redirecionarPagina('/rfarias/suporte/base-conhecimento/' + item.chamadoSuporte.id)">
							{{item.chamadoSuporte.tipo}} | {{item.conteudo | slice:0:255}}... 
						</div>

					</tr>
				</ng-template>
				<ng-template pTemplate="emptymessage">
					<tr>
						<td colspan="7">Nenhum registro encontrado.</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="loadingbody">
					<tr>
						<td colspan="7">Carregando grupos. Por favor aguarde.</td>
					</tr>
				</ng-template>
			</p-table>
		</div>
	</div>
</div>